import { Menu, Moon } from 'lucide-react';
import { useAuth } from '../../app/hooks/useAuth';
import { PesageButton } from '../ui/pesage';
import type { UserRole } from '../../entities/user/types';

const roleToSpaceName: Record<UserRole, string> = {
  manager: 'Espace Gestionnaire',
  agent: 'Espace Agent',
  accounting: 'Espace Comptable',
  super_admin: 'Espace Super Admin',
};

interface TopbarProps {
  onOpenSidebar?: () => void;
}

export function Topbar({ onOpenSidebar }: TopbarProps) {
  const { authState } = useAuth();
  const userRole = authState.user?.role;
  const companyName = authState.company?.name;

  const spaceName = userRole ? roleToSpaceName[userRole] : 'Espace';

  return (
    <div className="sticky top-0 z-10 flex min-h-14 items-center justify-between gap-3 border-b border-[#334155] bg-[#1e293b] px-4 py-3 font-mono text-[11px] uppercase tracking-[0.24em] text-slate-400 sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-700 bg-slate-800/80 text-slate-200 transition hover:border-slate-600 hover:bg-slate-700/80 lg:hidden"
          aria-label="Ouvrir le menu"
        >
          <Menu size={18} />
        </button>
        <div className="truncate font-semibold text-slate-200">{spaceName}</div>
      </div>

      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        <PesageButton
          variant="ghost"
          size="sm"
          icon={Moon}
          disabled
          aria-disabled="true"
          className="cursor-not-allowed border-none bg-transparent px-0 text-slate-400 opacity-60 hover:bg-transparent hover:text-slate-400"
        />
        <div className="h-4 w-px bg-[#334155]" />
        <span className="hidden truncate font-semibold text-slate-200 sm:inline">
          {companyName ?? 'Aucune société'}
        </span>
      </div>
    </div>
  );
}
